import { useAuthStore } from '../auth/useAuthStore'
import { authedJSON } from './http'

export interface PositionSample {
  symbol: string
  ts: number
  price: number
}

export interface PositionSamplesResponse {
  symbol: string
  startMs: number
  endMs: number
  points: { t: number; p: number }[]
}

function requireAccountId(): string {
  const accountId = useAuthStore.getState().accountId
  if (!accountId) throw new Error('No active account')
  return accountId
}

export async function postPositionSamples(
  samples: PositionSample[],
): Promise<{ written: number } | null> {
  if (!samples.length) return null
  const accountId = requireAccountId()
  return authedJSON<{ written: number }>('/api/position-samples', {
    method: 'POST',
    body: JSON.stringify({ accountId, samples }),
  })
}

export async function getPositionSamples(
  symbol: string,
  startMs: number,
  endMs: number,
): Promise<PositionSamplesResponse> {
  const accountId = requireAccountId()
  const params = new URLSearchParams({
    accountId,
    symbol,
    startMs: String(Math.floor(startMs)),
    endMs: String(Math.floor(endMs)),
  })
  return authedJSON<PositionSamplesResponse>(
    `/api/position-samples?${params}`,
  )
}
